/**
 * ChannelChoiceDescription component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channel choice description.
 */
const ChannelChoiceDescription = styled.p`
  color: white;
  font-size: ${30 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  line-height: ${40 * Screen.widthRatio}px;
  margin-bottom: 0;
  margin-top: 0;
  width: ${1520 * Screen.widthRatio}px;
  text-align: center;
`;

export default ChannelChoiceDescription;
